import { TEditorConfiguration } from "./documents/editor/core";

const LEGACY_HTML_BLOCK_ID = "block_legacy_html";

export function buildLegacyDocument(html: string): TEditorConfiguration {
  return {
    root: {
      type: "EmailLayout",
      data: {
        backdropColor: "#F5F5F5",
        canvasColor: "#FFFFFF",
        textColor: "#262626",
        fontFamily: "MODERN_SANS",
        childrenIds: [LEGACY_HTML_BLOCK_ID],
      },
    },
    [LEGACY_HTML_BLOCK_ID]: {
      type: "Html",
      data: {
        props: {
          contents: html,
        },
        style: {
          padding: {
            top: 16,
            bottom: 16,
            left: 24,
            right: 24,
          },
        },
      },
    },
  };
}
